import React from 'react'

export default function Block({
    style = {},
    text = '',
}) {
    return <div
        style={Object.assign({}, style)}
    >{text}</div>
}